// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ConfigService {
   data: any
   initialized: any
   injector: any
   plugins: any
   raw: any
   constructor(injector: any){
      this.initialize = this.initialize.bind(this)
      this.pluginInit = this.pluginInit.bind(this)
      this.fetch = this.fetch.bind(this)
      this.update = this.update.bind(this)
      this.injector = injector
      this.plugins = {}
      this.raw = {}
      this.data = {}
      this.initialize()
   }

   initialize() {
      if (this.initialized) { return }
      this.initialized = true
      // @ts-expect-error TS(2345) FIXME: Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
      const configs = angular.module(['summonApp.factories.configs'])._invokeQueue.map((service: any) => service[2][0])
      configs.forEach(this.pluginInit)
      this.fetch()
      return this.update()
   }

   pluginInit(factoryName: any){
      const config = this.injector.get(factoryName)
      const configName = factoryName.replace('Config', '')
      return this.plugins[configName] = config
   }

   // @ts-expect-error TS(2339) FIXME: Property '__configData' does not exist on type 'Wi... Remove this comment to see the full error message
   fetch(data = window.__configData) {
      return this.raw = data
   }

   update() {
      return (() => {
         const result = []
         for (var property in this.plugins) {
            var fn = this.plugins[property]
            result.push(this.data[property] = fn(this.raw))
         }
         return result
      })()
   }
}

ConfigService.$inject = ['$injector']

angular.module('summonApp.services')
   .service('configService', ConfigService)
